
import { Link, useLocation } from "react-router-dom";
import { Heart, Calendar, MessageSquare, User } from "lucide-react";
import { 
  Sidebar, 
  SidebarContent, 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton
} from "@/components/ui/sidebar";

export const ProfileSidebar = () => {
  const location = useLocation();
  
  const navItems = [
    {
      title: "My Profile",
      icon: User,
      href: "/my-profile",
    },
    {
      title: "My Favorites",
      icon: Heart,
      href: "/favorites",
    },
    {
      title: "My Bookings",
      icon: Calendar,
      href: "/my-bookings",
    },
    {
      title: "My Reviews",
      icon: MessageSquare,
      href: "/my-reviews",
    },
  ];

  return (
    <Sidebar>
      <SidebarContent className="z-10 pt-16">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {navItems.map((item) => {
                const Icon = item.icon;
                return (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton 
                      asChild
                      isActive={location.pathname === item.href}
                      tooltip={item.title}
                    >
                      <Link to={item.href} className="flex items-center gap-2">
                        <Icon className="h-5 w-5" />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};
